





































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import SearchIcon from 'mdi-vue/Magnify';
import DownloadIcon from 'mdi-vue/Download';
import { mapState } from 'vuex';
import api from '@/libs/api';
import { User } from '@/libs/api.interfaces';
import LayoutTitle from '@/components/LayoutTitle.vue';
import LayoutContent from '@/components/LayoutContent.vue';
import TagInput from '@/components/TagInput.vue';
import Toggle from '@/components/Toggle.vue';
import Table from '@/components/Table/Table.vue';
import Row from '@/components/Table/Row.vue';
import Header from '@/components/Table/Header.vue';
import SubHeader from '@/components/Table/SubHeader.vue';
import Cell from '@/components/Table/Cell.vue';
import Checkbox from '@/components/Checkbox.vue';
import Loader from '@/components/Loader.vue';
import Button from '@/components/Button.vue';
import Tab from '@/components/Tab/Tab.vue';
import SearchField from '@/components/SearchField.vue';
import SearchRow from '@/components/SearchRow.vue';
import Select from '@/components/Select.vue';
import DatePicker, { DateRange } from '@/components/DatePicker.vue';
// eslint-disable-next-line import/no-cycle
import { showToast } from '@/libs/toast';
import { ToastType } from '@/store/toast';
import dayjs from 'dayjs';
import ReportTable from './SingleMerchantTable.vue';

@Component({
  components: {
    LayoutTitle,
    LayoutContent,
    TagInput,
    Toggle,
    Table,
    Row,
    Header,
    SubHeader,
    Cell,
    Checkbox,
    Loader,
    Button,
    Tab,
    SearchIcon,
    DownloadIcon,
    DatePicker,
    SearchField,
    SearchRow,
    Select,
    ReportTable,
  },
  computed: mapState(['user']),
})
export default class Report extends Vue {
  user!: {
    user: User;
  };

  status: LabelValue | null = null;

  currentChannel = {
    title: 'Credit Card',
    code: 'creditcard',
    path: 'creditcard',
  }

  statuses = [
    {
      label: 'All',
      value: '',
    }, {
      label: 'ACTIVE',
      value: 'ACTIVE',
    }, {
      label: 'INACTIVE',
      value: 'INACTIVE',
    },
  ]

  searchOpen = false;

  transactionDate: DateRange = {
    startDate: null,
    endDate: null,
  }

  selectedBrand: { merchant_brand: string } | null = null;

  selectedMerchants: { merchant_code: string; merchant_name: string } | null = null;
  tagIds: SelectItem[] = []
  channelIds: string[] = []
  loadingMerchant = false;
  loadingExport = false;

  channelIdList: string[] = [];
  loadingChannelId = false;

  merchants = [
    {
      /* eslint-disable @typescript-eslint/camelcase */
      merchant_code: '',
      merchant_name: 'Enter merchant name',
      $isDisabled: true,
      /* eslint-enable @typescript-eslint/camelcase */
    },
  ];

  // pagination
  page = 1;
  totalPage = 1;
  from = 0;
  to = 0;
  totalItem = 0;

  $refs!: {
    report: ReportTable;
  }

  format!: (val: string) => string;

  mounted() {
    this.parseParams();
    // this.getChannelIds();
  }

  @Watch('$route')
  onRouteChange() {
    this.parseParams();
  }

  // async getChannelIds(merchant?: string[]) {
  //   try {
  //     this.loadingChannelId = true;
  //     const { data } = await api.get<ChannelIdResponse>('/transaction/channels', {
  //       params: {
  //         // eslint-disable-next-line @typescript-eslint/camelcase
  //         merchant_code: merchant || undefined,
  //       },
  //     });
  //     this.channelIdList = data.data.map((e) => e.channel_id);
  //     this.loadingChannelId = false;
  //   } catch (err) {
  //     console.error(err);
  //   }
  // }

  // @Watch('selectedMerchants')
  // onMerchantChange() {
  //   this.getChannelIds(this.selectedMerchants.map((e) => e.merchant_code));
  // }

  async getMerchants(query: string, value: string) {
    if (query === '') return;

    try {
      this.loadingMerchant = true;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const params: any = {};
      params[query] = value;
      const { data } = await api.get('/consumer/merchant', {
        params,
      });
      this.merchants = data.data;
      this.loadingMerchant = false;
      console.log();
    } catch (err) {
      console.error(err);
    }
  }

  async getTransaction(isExport = false, page: number) {
    const params = {
      // channel: this.currentChannel,
      // channelIds: this.channelIds,
      merchant: this.selectedMerchants,
      transactionDate: this.transactionDate,
      brand: this.selectedBrand,
      status: this.status,
    };

    if (isExport) {
      await this.$refs.report.getTransaction(params, true, page);
    } else {
      await this.$refs.report.getTransaction(params, false, page);
    }
  }

  parseParams() {
    const params = this.$route.query;

    if (typeof params.td === 'string') {
      const dates = params.td.split(',');
      this.transactionDate = {
        startDate: dayjs(dates[0]).toDate().toString(),
        endDate: dayjs(dates[1]).toDate().toString(),
      };
    } else {
      this.transactionDate = {
        startDate: null,
        endDate: null,
      };
    }

    if (typeof params.mc === 'string') {
      const merchant = JSON.parse(params.mc);
      this.selectedMerchants = merchant;
    } else {
      this.selectedMerchants = null;
    }

    if (typeof params.br === 'string') {
      const brand = JSON.parse(params.br);
      this.selectedBrand = brand;
    } else {
      this.selectedBrand = null;
    }

    if (typeof params.ch === 'string') {
      const channelIds = params.ch.split(',');
      this.channelIds = channelIds;
    } else {
      this.channelIds = [];
    }

    let page = 1;
    if (typeof params.page === 'string') {
      page = Number(params.page);
    }

    this.getTransaction(false, page);
  }

  search() {
    this.$router.push({
      query: {
        mc: this.selectedMerchants === null ? undefined : JSON.stringify(this.selectedMerchants),
        td: this.transactionDate.startDate && this.transactionDate.endDate
          ? this.transactionDate && `${this.transactionDate.startDate},${this.transactionDate.endDate}` : undefined,
        br: this.selectedBrand === null ? undefined : JSON.stringify(this.selectedBrand),
        st: this.status === null ? undefined : this.status.value,
      },
    });
  }

  async exportData() {
    showToast(ToastType.SUCCESS, 'Export Transaction', 'Export is starting, please wait! This may take a while');
    this.loadingExport = true;
    // eslint-disable-next-line radix
    await this.getTransaction(true, this.$route.query.page ? parseInt(this.$route.query.page.toString()) : 1);
    this.loadingExport = false;
  }

  cancel() {
    this.transactionDate = {
      startDate: null,
      endDate: null,
    };
    this.selectedMerchants = null;
    this.tagIds = [];
    this.channelIds = [];
    this.selectedBrand = null;
    this.transactionDate = {
      startDate: null,
      endDate: null,
    };

    this.$router.push({
      query: {},
    });
  }

  toggleSearchOpen() {
    this.searchOpen = !this.searchOpen;
  }
}
